export const formatDate = isoDate => {
  if (!isoDate) {
    return null;
  }
  const date = new Date(isoDate);
  let day = date.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  const year = date.getFullYear();
  return day + "." + month + "." + year;
};

export const formatTrademarkPath = item => {
  if (!item) {
    return null;
  }
  let pathEnding = "";
  if (item.applicationNumber && item.registrationNumber) {
    pathEnding = item.applicationNumber + "/" + item.registrationNumber;
  } else {
    pathEnding = item.applicationNumber;
  }
  return pathEnding;
};

export const createImgUrl = item => {
  return (
    "https://epalvelut-testi.prh.fi/opendata/trademark/image/" +
    formatTrademarkPath(item)
  );
};

export const createThumbnailUrl = item => {
  return (
    "https://epalvelut-testi.prh.fi/opendata/trademark/thumbnail/" +
    formatTrademarkPath(item)
  );
};

export default false;
